module.exports = {
  // Style prefix
  stylePrefix: 'clm-',

  // Specify the element to use as a container, string (query) or HTMLElement
  // With the empty value, nothing will be rendered
  appendTo: '',

  // Default selectors
  selectors: [],

  // Label for selectors
  label: window.lang['classes'],

  // Label for states
  statesLabel: window.lang['state'],

  selectedLabel: window.lang['selected'],

  // States
  states: [
    { name: 'hover', label: window.lang['hover'] },
    { name: 'active', label: window.lang['click'] },
    { name: 'nth-of-type(2n)', label: window.lang['parity'] }
  ]
};
